import { render, staticRenderFns } from "./WakaDev.vue?vue&type=template&id=ce57ee70&"
import script from "./WakaDev.vue?vue&type=script&lang=js&"
export * from "./WakaDev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports